import { render, staticRenderFns } from "./AsuUpdatePrice.vue?vue&type=template&id=4f09207e"
import script from "./AsuUpdatePrice.vue?vue&type=script&lang=js"
export * from "./AsuUpdatePrice.vue?vue&type=script&lang=js"
import style0 from "./AsuUpdatePrice.vue?vue&type=style&index=0&id=4f09207e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports